import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FooterBreadCrumb from '../../components/common-footer/FooterBreadCrumb';

const ServiceUseNotice = () => {
  const navigate = useNavigate();

  const handleGoToMain = () => {
    navigate('/');
  };

  // Desktop View - Use desktop header and footer
  return (
    <div className="service-use-notice announcement-list-page">
      <div className="content-wrapper">
        <FooterBreadCrumb heading="서비스 이용 공지" />
        <div className="rectangle-background">
          <div className="rectangle-inner">
            <div className="main-message">
              <p>서비스 이용에 불편을 드려 죄송합니다.</p>
            </div>
            <div className="explanation-text">
              <p>
                방문하시려는 웹 페이지의 주소가 잘못 입력되었거나,<br />
                변경 또는 삭제되어 요청하신 페이지를 찾을 수 없습니다.<br />
                새로 고침(F5)을 하시거나 페이지 확인 후 다시 접속해 주시기 바랍니다.
              </p>
            </div>
            <div className="cta-section">
              <button
                className="go-to-main-btn"
                onClick={handleGoToMain}
              >
                메인으로 이동
              </button>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default ServiceUseNotice; 